import { useState } from "react";
import { CalendarClock, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { formatDatePl, warsawLocal } from "./templateUtils";

const pad = (n) => String(n).padStart(2, "0");
const isoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const shift = (ymd, n) => { const d = new Date(`${ymd}T12:00:00`); d.setDate(d.getDate() + n); return isoDate(d); };
const later = (min) => warsawLocal(new Date(Date.now() + min * 60000));

export const ScheduleModal = ({ eventDate, current, busy, onClose, onConfirm }) => {
    const today = warsawLocal().slice(0, 10);
    const initial = current ? warsawLocal(new Date(current)) : `${shift(today, 1)}T08:00`;
    const [date, setDate] = useState(initial.slice(0, 10));
    const [time, setTime] = useState(initial.slice(11, 16));

    const tooSoon = !!date && !!time && `${date}T${time}` < later(2);
    const presets = [["Jutro 8:00", shift(today, 1), "08:00"], ["Za tydzień 8:00", shift(today, 7), "08:00"]];
    if (eventDate) {
        const dayBefore = shift(eventDate, -1);
        if (`${dayBefore}T18:00` > later(5)) {
            presets.unshift([`Dzień przed wydarzeniem: ${formatDatePl(dayBefore)} 18:00`, dayBefore, "18:00"]);
        }
    }

    return (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-7 space-y-5" onClick={(e) => e.stopPropagation()} data-testid="mailing-schedule-modal">
                <div className="flex items-center justify-between">
                    <h3 className="font-serif text-2xl text-[#092E22] flex items-center gap-2"><CalendarClock size={20} /> Zaplanuj wysyłkę</h3>
                    <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100"><X size={18} /></button>
                </div>
                <div className="flex flex-wrap gap-2">
                    {presets.map(([label, d, t], i) => (
                        <button key={label} type="button" onClick={() => { setDate(d); setTime(t); }} data-testid={`mailing-schedule-preset-${i}`}
                            className="px-3 py-1.5 rounded-full text-xs border border-[#0D4F3C]/30 text-[#0D4F3C] hover:bg-[#0D4F3C]/5">{label}</button>
                    ))}
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-1.5"><Label>Data</Label><Input type="date" min={today} value={date} onChange={(e) => setDate(e.target.value)} data-testid="mailing-schedule-date" /></div>
                    <div className="space-y-1.5"><Label>Godzina</Label><Input type="time" value={time} onChange={(e) => setTime(e.target.value)} data-testid="mailing-schedule-time" /></div>
                </div>
                {tooSoon && <p className="text-xs text-red-600" data-testid="mailing-schedule-past-warning">Wybrany termin jest w przeszłości lub za mniej niż 2 minuty.</p>}
                <p className="text-xs text-gray-500">Czas polski (Europe/Warsaw). Odbiorcy zostaną pobrani z grup w chwili wysyłki. Do tego czasu możesz edytować kampanię lub anulować planowanie.</p>
                <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={onClose} className="rounded-full">Anuluj</Button>
                    <Button onClick={() => onConfirm(`${date}T${time}`)} disabled={busy || !date || !time || tooSoon} className="rounded-full bg-[#0D4F3C] hover:bg-[#092E22] text-white" data-testid="mailing-schedule-confirm">
                        {busy ? "Zapisywanie…" : `Zaplanuj na ${formatDatePl(date)} ${time}`}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ScheduleModal;
